const ClickOutside = (callback): void => {
  function clickEvent(e: Event) {
    const target = e.target as HTMLElement;

    const trigger = target.closest(".co-trigger");
    const openElements = document.querySelectorAll(".co-el.open") as NodeListOf<HTMLElement>;

    if (trigger) {
      const parent = trigger.parentElement;
      const relatedDropdown = parent?.querySelector(".co-el");

      // openElements.forEach((dropdown) => {
      //   if (dropdown !== relatedDropdown) {
      //     dropdown.classList.remove("open");
      //   } else {
      //   }
      // });

      return;
    }

    callback();

    openElements.forEach((dropdown) => {
      dropdown.classList.remove("open");
    });
  }

  function keyboardEvent(e: KeyboardEvent) {
    const keys = e.keyCode || e.which;
    if (keys === 27) {
      callback();

      const openElements = document.querySelectorAll(".open") as NodeListOf<HTMLElement>;
      openElements.forEach((item) => {
        if (item.classList.contains("open")) {
          item.classList.remove("open");
        }
      });
    }
  }

  // Clicks
  document.removeEventListener("click", clickEvent, false);
  document.addEventListener("click", clickEvent, false);

  // ESC key
  document.removeEventListener("keyup", keyboardEvent);
  document.addEventListener("keyup", keyboardEvent);
};

export default ClickOutside;
